import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';

const OperationDeleteModal = ({ onDelete, setModalVisible }) => {
  const { t } = useTranslation();

  const onClose = () => setModalVisible({ selectedId: null, visible: false });

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: t(translations.activityModel_deleteOperation),
          content: <>{t(translations.activityModel_areYouSureYouWantToDeleteThisOperation)}</>,
          footer: (
            <>
              <Button label={t(translations.delete)} colored onClick={onDelete} testId="delete-modal-button-delete" />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

export { OperationDeleteModal };
